module.exports = __webpack_public_path__ + "img/usdt.eac1f7bb.svg";